import { useEffect } from 'react';
import { normalizePathname } from '../../config/staticPageMeta';
import type { Article } from '../../utils/articleApi';
import { buildArticleJsonLd } from '../../utils/articleJsonLd';

const SCRIPT_ATTR = 'data-social-trip-article-jsonld';

/**
 * 記事詳細ページに Article JSON-LD を注入（アンマウント時に除去）
 */
export default function ArticleJsonLd({ article }: { article: Article }) {
  useEffect(() => {
    /** ビルド時プリレンダで head に入っている場合は二重挿入しない（ローカル dev は無いので従来どおり CSR で注入） */
    if (document.querySelector('script[data-article-jsonld="prerender"]')) {
      return undefined;
    }
    const origin = window.location.origin.replace(/\/$/, '');
    const norm = normalizePathname(window.location.pathname);
    const pageUrl = norm === '/' ? `${origin}/` : `${origin}${norm}`;
    const json = buildArticleJsonLd(article, pageUrl);
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.setAttribute(SCRIPT_ATTR, 'true');
    el.textContent = JSON.stringify(json).replace(/</g, '\\u003c');
    document.head.appendChild(el);
    return () => {
      document.head.querySelectorAll(`script[${SCRIPT_ATTR}]`).forEach((n) => n.remove());
    };
  }, [
    article.id,
    article.title,
    article.excerpt,
    article.image,
    article.author,
    article.publishedAt,
  ]);

  return null;
}
